import { userDataActions } from './slice';

export const changeSelectedLanguage =
  userDataActions.changeSelectedLanguage as (lang: string) => void;

export const submitFeedBack = userDataActions.submitFeedBack as (payload: {
  userId?: string;
  rating?: number;
  comment?: string;
  submitted: boolean;
}) => void;
